'use es6';

/*
 * Generated by PEG.js 0.10.0.
 *
 * http://pegjs.org/
 */

/* eslint-disable */
function peg$subclass(child, parent) {
  function ctor() {
    this.constructor = child;
  }
  ctor.prototype = parent.prototype;
  child.prototype = new ctor();
}
function peg$SyntaxError(message, expected, found, location) {
  this.message = message;
  this.expected = expected;
  this.found = found;
  this.location = location;
  this.name = 'SyntaxError';
  if (typeof Error.captureStackTrace === 'function') {
    Error.captureStackTrace(this, peg$SyntaxError);
  }
}
peg$subclass(peg$SyntaxError, Error);
peg$SyntaxError.buildMessage = function (expected, found) {
  var DESCRIBE_EXPECTATION_FNS = {
    literal: function (expectation) {
      return '"' + literalEscape(expectation.text) + '"';
    },
    class: function (expectation) {
      var escapedParts = '',
        i;
      for (i = 0; i < expectation.parts.length; i++) {
        escapedParts += expectation.parts[i] instanceof Array ? classEscape(expectation.parts[i][0]) + '-' + classEscape(expectation.parts[i][1]) : classEscape(expectation.parts[i]);
      }
      return '[' + (expectation.inverted ? '^' : '') + escapedParts + ']';
    },
    any: function (expectation) {
      return 'any character';
    },
    end: function (expectation) {
      return 'end of input';
    },
    other: function (expectation) {
      return expectation.description;
    }
  };
  function hex(ch) {
    return ch.charCodeAt(0).toString(16).toUpperCase();
  }
  function literalEscape(s) {
    return s.replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/\0/g, '\\0').replace(/\t/g, '\\t').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/[\x00-\x0F]/g, function (ch) {
      return '\\x0' + hex(ch);
    }).replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) {
      return '\\x' + hex(ch);
    });
  }
  function classEscape(s) {
    return s.replace(/\\/g, '\\\\').replace(/\]/g, '\\]').replace(/\^/g, '\\^').replace(/-/g, '\\-').replace(/\0/g, '\\0').replace(/\t/g, '\\t').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/[\x00-\x0F]/g, function (ch) {
      return '\\x0' + hex(ch);
    }).replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) {
      return '\\x' + hex(ch);
    });
  }
  function describeExpectation(expectation) {
    return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
  }
  function describeExpected(expected) {
    var descriptions = new Array(expected.length),
      i,
      j;
    for (i = 0; i < expected.length; i++) {
      descriptions[i] = describeExpectation(expected[i]);
    }
    descriptions.sort();
    if (descriptions.length > 0) {
      for (i = 1, j = 1; i < descriptions.length; i++) {
        if (descriptions[i - 1] !== descriptions[i]) {
          descriptions[j] = descriptions[i];
          j++;
        }
      }
      descriptions.length = j;
    }
    switch (descriptions.length) {
      case 1:
        return descriptions[0];
      case 2:
        return descriptions[0] + ' or ' + descriptions[1];
      default:
        return descriptions.slice(0, -1).join(', ') + ', or ' + descriptions[descriptions.length - 1];
    }
  }
  function describeFound(found) {
    return found ? '"' + literalEscape(found) + '"' : 'end of input';
  }
  return 'Expected ' + describeExpected(expected) + ' but ' + describeFound(found) + ' found.';
};
function peg$parse(input, options) {
  options = options !== void 0 ? options : {};
  var peg$FAILED = {},
    peg$startRuleIndices = {
      Start: 0
    },
    peg$startRuleIndex = 0,
    peg$consts = [function (head, tail) {
      const result = buildList(head, tail, 1).filter(id => id);
      return result.length > 1 ? expressions(result) : head;
    }, function () {
      return MISSING;
    }, ',', peg$literalExpectation(',', false), '{', peg$literalExpectation('{', false), '}', peg$literalExpectation('}', false), '(', peg$literalExpectation('(', false), ')', peg$literalExpectation(')', false), '[', peg$literalExpectation('[', false), ']', peg$literalExpectation(']', false), "'", peg$literalExpectation("'", false), '"', peg$literalExpectation('"', false), peg$anyExpectation(), function (exp) {
      return exp;
    }, function () {
      return undefined;
    }, function (input) {
      return symbol(input);
    }, function (input) {
      return unrecognized(input);
    }, peg$otherExpectation('whitespace'), '\t', peg$literalExpectation('\t', false), '\x0B', peg$literalExpectation('\x0B', false), '\f', peg$literalExpectation('\f', false), ' ', peg$literalExpectation(' ', false), '\xA0', peg$literalExpectation('\xA0', false), '\uFEFF', peg$literalExpectation('\uFEFF', false), /^[\n\r\u2028\u2029]/, peg$classExpectation(['\n', '\r', '\u2028', '\u2029'], false, false), peg$otherExpectation('end of line'), '\n', peg$literalExpectation('\n', false), '\r\n', peg$literalExpectation('\r\n', false), '\r', peg$literalExpectation('\r', false), '\u2028', peg$literalExpectation('\u2028', false), '\u2029', peg$literalExpectation('\u2029', false), '.', peg$literalExpectation('.', false), function (name) {
      return name;
    }, peg$otherExpectation('identifier'), function (head, tail) {
      return {
        type: 'IDENTIFIER',
        name: head + tail.join(''),
        recovered: false,
        location: location()
      };
    }, '$', peg$literalExpectation('$', false), '_', peg$literalExpectation('_', false), '\u200C', peg$literalExpectation('\u200C', false), '\u200D', peg$literalExpectation('\u200D', false), function () {
      return {
        type: 'NULL_LITERAL',
        value: null,
        recovered: false,
        location: location()
      };
    }, function () {
      return {
        type: 'BOOLEAN_LITERAL',
        value: true,
        recovered: false,
        location: location()
      };
    }, function () {
      return {
        type: 'BOOLEAN_LITERAL',
        value: false,
        recovered: false,
        location: location()
      };
    }, peg$otherExpectation('number'), function (literal) {
      return literal;
    }, function () {
      return {
        type: 'NUMERIC_LITERAL',
        value: parseFloat(text()),
        recovered: false,
        location: location()
      };
    }, '0', peg$literalExpectation('0', false), /^[0-9]/, peg$classExpectation([['0', '9']], false, false), /^[1-9]/, peg$classExpectation([['1', '9']], false, false), /^[+\-]/, peg$classExpectation(['+', '-'], false, false), peg$otherExpectation('string'), function (chars) {
      return {
        type: 'STRING_LITERAL',
        value: chars.join(''),
        recovered: false,
        location: location()
      };
    }, function (chars) {
      return {
        type: 'STRING_LITERAL',
        value: chars.join(''),
        recovered: false,
        location: location()
      };
    }, function () {
      return text();
    }, '\\', peg$literalExpectation('\\', false), function () {
      return '';
    }, /^[a-z]/, peg$classExpectation([['a', 'z']], false, false), /^[A-Z]/, peg$classExpectation([['A', 'Z']], false, false), /^[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/, peg$classExpectation([' ', '\xA0', '\u1680', ['\u2000', '\u200A'], '\u202F', '\u205F', '\u3000'], false, false), 'true', peg$literalExpectation('true', false), 'TRUE', peg$literalExpectation('TRUE', false), 'false', peg$literalExpectation('false', false), 'FALSE', peg$literalExpectation('FALSE', false), 'null', peg$literalExpectation('null', false), 'NULL', peg$literalExpectation('NULL', false), 'and', peg$literalExpectation('and', false), 'AND', peg$literalExpectation('AND', false), 'or', peg$literalExpectation('or', false), 'OR', peg$literalExpectation('OR', false), function (expression, r) {
      return expression ? Object.assign({}, expression, {
        recovered: !r
      }) : MISSING;
    }, function (table, name) {
      return {
        type: 'PROPERTY',
        table: table.name,
        name: name.name,
        recovered: false,
        location: location()
      };
    }, function (table, name) {
      return {
        type: 'PROPERTY',
        table: table.join('').trim(),
        name: extractList(name, 0).join('').trim(),
        recovered: true,
        location: location()
      };
    }, function (l, chars, r) {
      return {
        type: 'FIELD',
        name: chars.join(''),
        recovered: !(l.length === 1 && r.length === 1),
        location: location()
      };
    }, function (chars) {
      return {
        type: 'FIELD',
        name: chars.join('').trim(),
        recovered: true,
        location: location()
      };
    }, ':', peg$literalExpectation(':', false), function (dimensions, exp) {
      return {
        type: 'AGGREGATION_CONTEXT',
        dimensions: dimensions,
        expression: exp,
        recovered: false,
        location: location()
      };
    }, function (exp) {
      return {
        type: 'AGGREGATION_CONTEXT',
        dimensions: [],
        expression: exp,
        recovered: false,
        location: location()
      };
    }, function (identifier, args) {
      return {
        type: 'FUNCTION_CALL',
        name: identifier.name,
        arguments: args.arguments,
        recovered: args.recovered,
        location: location(),
        identifierLocation: identifier.location,
        invocationLocation: args.invocationLocation,
        invocationLocationWithParens: args.invocationLocationWithParens,
        argumentLocations: args.argumentLocations
      };
    }, function (args, closed) {
      const actualArguments = args.arguments.length === 1 && args.arguments[0].type === 'MISSING' ? [] : args.arguments;
      return {
        arguments: actualArguments,
        argumentLocations: args.argumentLocations,
        invocationLocation: args.location,
        invocationLocationWithParens: location(),
        recovered: !closed
      };
    }, function (argument) {
      return {
        argument: argument || Object.assign({}, MISSING, {
          location: location()
        }),
        location: location()
      };
    }, function (head, tail) {
      const result = [head].concat(extractList(tail, 1));
      return {
        arguments: result.map(({
          argument
        }) => argument),
        argumentLocations: result.map(({
          location
        }) => location),
        location: location()
      };
    }, function (operator, argument) {
      return {
        type: getUnaryExpressionType(operator),
        operator: operator,
        argument: argument,
        recovered: false,
        prefix: true,
        location: location()
      };
    }, '+', peg$literalExpectation('+', false), '=', peg$literalExpectation('=', false), '-', peg$literalExpectation('-', false), '!', peg$literalExpectation('!', false), '&&', peg$literalExpectation('&&', false), '||', peg$literalExpectation('||', false), function (operator, argument) {
      return {
        type: getBinaryExpressionType(operator),
        operator: operator,
        left: MISSING,
        right: argument,
        recovered: true,
        location: location()
      };
    }, function (head, tail) {
      return buildBinaryExpression(head, tail, location());
    }, '*', peg$literalExpectation('*', false), '/', peg$literalExpectation('/', false), '%', peg$literalExpectation('%', false), /^[+=]/, peg$classExpectation(['+', '='], false, false), /^[\-=]/, peg$classExpectation(['-', '='], false, false), '<=', peg$literalExpectation('<=', false), '>=', peg$literalExpectation('>=', false), '<', peg$literalExpectation('<', false), '>', peg$literalExpectation('>', false), '==', peg$literalExpectation('==', false), '!=', peg$literalExpectation('!=', false), function (head, tail) {
      return buildBinaryExpression(head, tail, location());
    }, function (operator) {
      return {
        type: getBinaryExpressionType(operator),
        operator: operator,
        left: MISSING,
        right: MISSING,
        recovered: true,
        location: location()
      };
    }, function (argument, operator) {
      return {
        type: getBinaryExpressionType(operator),
        operator: operator,
        left: argument,
        right: MISSING,
        recovered: true,
        location: location()
      };
    }, function (head, tail) {
      const result = buildList(head, tail, 1);
      return result.length > 1 ? expressions(result) : head;
    }],
    peg$bytecode = [peg$decode("%;G/q#;#/h$$%;G/,#;#/#$+\")(\"'#&'#06*%;G/,#;#/#$+\")(\"'#&'#&/2$;G/)$8$: $\"\"!)($'#(#'#(\"'#&'#.. &%;G/& 8!:!! )"), peg$decode('2"""6"7#.} &2$""6$7%.q &2&""6&7\'.e &2(""6(7).Y &2*""6*7+.M &2,""6,7-.A &2.""6.7/.5 &20""6071.) &22""6273'), peg$decode('$%%<;!.# &;+=.##&&!&\'#/1#1""5!74/#$+")("\'#&\'#/P#0M*%%<;!.# &;+=.##&&!&\'#/1#1""5!74/#$+")("\'#&\'#&&&#'), peg$decode('%;b/\' 8!:5!! ).` &%;F/& 8!:6! ).O &%%;!/"!&,)/\' 8!:7!! ).6 &%%;"/"!&,)/\' 8!:8!! )'), peg$decode('1""5!74'), peg$decode('<2:""6:7;._ &2<""6<7=.S &2>""6>7?.G &2@""6@7A.; &2B""6B7C./ &2D""6D7E.# &;@=." 79'), peg$decode('4F""5!7G'), peg$decode('<2I""6I7J.M &2K""6K7L.A &2M""6M7N.5 &2O""6O7P.) &2Q""6Q7R=." 7H'), peg$decode('%%<;-=.##&&!&\'#/a#;)/X$;G/O$%<2S""6S7T.) &2.""6.7/=.##&&!&\'#/($8$:U$!")($\'#(#\'#("\'#&\'#'), peg$decode('<%;*/9#$;+0#*;+&/)$8":W""! )("\'#&\'#=." 7V'), peg$decode(';,.5 &2X""6X7Y.) &2Z""6Z7['), peg$decode(';*.; &;?.5 &2\\""6\\7].) &2^""6^7_'), peg$decode(';>.# &;='), peg$decode(';..) &;0.# &;1'), peg$decode(';D.# &;E'), peg$decode(';0./ &;1.) &;2.# &;8'), peg$decode('%;C/& 8!:`! )'), peg$decode('%;A/& 8!:a! ).. &%;B/& 8!:b! )'), peg$decode('<%;3/\' 8!:d!! )=." 7c'), peg$decode('%;4/F#2S""6S7T/7$$;50#*;5&/\'$8#:e# )(#\'#("\'#&\'#.^ &%2S""6S7T/=#$;5/&#0#*;5&&&#/\'$8":e" )("\'#&\'#.. &%;4/& 8!:e! )'), peg$decode('2f""6f7g.= &%;6/3#$;50#*;5&/#$+")("\'#&\'#'), peg$decode('4h""5!7i'), peg$decode('4j""5!7k'), peg$decode('%4l""5!7m." &"/9#$;5/&#0#*;5&&&#/#$+")("\'#&\'#'), peg$decode('<%22""6273/G#$;90#*;9&/7$22""6273/($8#:o#!!)(#\'#("\'#&\'#.W &%20""6071/G#$;:0#*;:&/7$20""6071/($8#:p#!!)(#\'#("\'#&\'#=." 7n'), peg$decode('%%<22""6273.# &;&=.##&&!&\'#/0#;$/\'$8":q" )("\'#&\'#.# &;<'), peg$decode('%%<20""6071.# &;&=.##&&!&\'#/0#;$/\'$8":q" )("\'#&\'#.# &;<'), peg$decode('%%<2,""6,7-.; &2.""6.7/./ &2S""6S7T.# &;&=.##&&!&\'#/0#;$/\'$8":q" )("\'#&\'#'), peg$decode('%2r""6r7s/0#;\'/\'$8":t" )("\'#&\'#'), peg$decode('4u""5!7v'), peg$decode('4w""5!7x'), peg$decode('4h""5!7i'), peg$decode('4y""5!7z'), peg$decode('%2{""6{7|.) &2}""6}7~/8#%<;+=.##&&!&\'#/#$+")("\'#&\'#'), peg$decode('%2\x7F""6\x7F7\x80.) &2\x81""6\x817\x82/8#%<;+=.##&&!&\'#/#$+")("\'#&\'#'), peg$decode('%2\x83""6\x837\x84.) &2\x85""6\x857\x86/8#%<;+=.##&&!&\'#/#$+")("\'#&\'#'), peg$decode('%2\x87""6\x877\x88.) &2\x89""6\x897\x8A/8#%<;+=.##&&!&\'#/#$+")("\'#&\'#'), peg$decode('%2\x8B""6\x8B7\x8C.) &2\x8D""6\x8D7\x8E/8#%<;+=.##&&!&\'#/#$+")("\'#&\'#'), peg$decode("$;%.# &;'/,#0)*;%.# &;'&&&#"), peg$decode("$;%.# &;'0)*;%.# &;'&"), peg$decode('$;%0#*;%&'), peg$decode(';/.\x7F &;J.y &;K.s &;(.m &%2(""6(7)/]#;G/T$;b." &"/F$;G/=$2*""6*7+." &"/)$8%:\x8F%"" )(%\'#($\'#(#\'#("\'#&\'#'), peg$decode('%2,""6,7-/k#;G/b$;)/Y$2S""6S7T/J$;)/A$;G/8$2.""6.7//)$8\':\x90\'"$")(\'\'#(&\'#(%\'#($\'#(#\'#("\'#&\'#.\xF9 &%$2,""6,7-0)*2,""6,7-&/\xDC#;G/\xD3$$;+.# &;%0)*;+.# &;%&/\xB7$2S""6S7T/\xA8$$%;+.# &;%/8#%<;M=.##&&!&\'#/#$+")("\'#&\'#0H*%;+.# &;%/8#%<;M=.##&&!&\'#/#$+")("\'#&\'#&/N$;G/E$$2.""6.7/0)*2.""6.7/&/)$8\':\x91\'"$")(\'\'#(&\'#(%\'#($\'#(#\'#("\'#&\'#'), peg$decode('%$2,""6,7-/,#0)*2,""6,7-&&&#/n#;G/e$$;;0#*;;&/U$;G/L$$2.""6.7//,#0)*2.""6.7/&&&#/*$8%:\x92%#$" )(%\'#($\'#(#\'#("\'#&\'#.\xC3 &%$2,""6,7-/,#0)*2,""6,7-&&&#/M#;G/D$$;+.# &;%0)*;+.# &;%&/($8#:\x93#! )(#\'#("\'#&\'#.p &%$;+.# &;%0)*;+.# &;%&/S#;G/J$$2.""6.7//,#0)*2.""6.7/&&&#/($8#:\x93#!")(#\'#("\'#&\'#'), peg$decode("%2$\"\"6$7%/}#;G/t$;P/k$;G/b$2\x94\"\"6\x947\x95/S$;G/J$;b/A$;G/8$2&\"\"6&7'/)$8):\x96)\"&\")()'#(('#(''#(&'#(%'#($'#(#'#(\"'#&'#.b &%2$\"\"6$7%/R#;G/I$;b/@$;G/7$2&\"\"6&7'/($8%:\x97%!\")(%'#($'#(#'#(\"'#&'#"), peg$decode('%;(/;#;G/2$;N/)$8#:\x98#"" )(#\'#("\'#&\'#'), peg$decode('%2(""6(7)/F#;P/=$2*""6*7+." &"/)$8#:\x99#"! )(#\'#("\'#&\'#'), peg$decode('%;G/?#;b." &"/1$;G/($8#:\x9A#!!)(#\'#("\'#&\'#'), peg$decode('%;O/k#$%2"""6"7#/,#;O/#$+")("\'#&\'#0<*%2"""6"7#/,#;O/#$+")("\'#&\'#&/)$8":\x9B""! )("\'#&\'#'), peg$decode(';M.W &;L.Q &;T.K &;I.E &%;R/;#;G/2$;Q/)$8#:\x9C#"" )(#\'#("\'#&\'#'), peg$decode('%%2\x9D""6\x9D7\x9E/>#%<2\x9F""6\x9F7\xA0=.##&&!&\'#/#$+")("\'#&\'#/"!&,).h &%%2\xA1""6\xA17\xA2/>#%<2\x9F""6\x9F7\xA0=.##&&!&\'#/#$+")("\'#&\'#/"!&,).0 &%2\xA3""6\xA37\xA4/"!&,)'), peg$decode(';V.S &;X.M &;Z.G &;\\.A &2\xA5""6\xA57\xA6.5 &2\xA7""6\xA77\xA8.) &;D.# &;E'), peg$decode('%%%%<;R=.##&&!&\'#/3#%;S/"!&,)/#$+")("\'#&\'#/"!&,)/;#;G/2$;Q/)$8#:\xA9#"" )(#\'#("\'#&\'#'), peg$decode("%;Q/\x83#$%;G/>#;V/5$;G/,$;Q/#$+$)($'#(#'#(\"'#&'#0H*%;G/>#;V/5$;G/,$;Q/#$+$)($'#(#'#(\"'#&'#&/)$8\":\xAA\"\"! )(\"'#&'#"), peg$decode('%%2\xAB""6\xAB7\xAC/>#%<2\x9F""6\x9F7\xA0=.##&&!&\'#/#$+")("\'#&\'#/"!&,).\x8D &%%2\xAD""6\xAD7\xAE/>#%<2\x9F""6\x9F7\xA0=.##&&!&\'#/#$+")("\'#&\'#/"!&,).U &%%2\xAF""6\xAF7\xB0/>#%<2\x9F""6\x9F7\xA0=.##&&!&\'#/#$+")("\'#&\'#/"!&,)'), peg$decode("%;U/\x83#$%;G/>#;X/5$;G/,$;U/#$+$)($'#(#'#(\"'#&'#0H*%;G/>#;X/5$;G/,$;U/#$+$)($'#(#'#(\"'#&'#&/)$8\":\xAA\"\"! )(\"'#&'#"), peg$decode('%%2\x9D""6\x9D7\x9E/>#%<4\xB1""5!7\xB2=.##&&!&\'#/#$+")("\'#&\'#/"!&,).U &%%2\xA1""6\xA17\xA2/>#%<4\xB3""5!7\xB4=.##&&!&\'#/#$+")("\'#&\'#/"!&,)'), peg$decode("%;W/\x83#$%;G/>#;Z/5$;G/,$;W/#$+$)($'#(#'#(\"'#&'#0H*%;G/>#;Z/5$;G/,$;W/#$+$)($'#(#'#(\"'#&'#&/)$8\":\xAA\"\"! )(\"'#&'#"), peg$decode('2\xB5""6\xB57\xB6.\x99 &2\xB7""6\xB77\xB8.\x8D &%%2\xB9""6\xB97\xBA/>#%<2\xB9""6\xB97\xBA=.##&&!&\'#/#$+")("\'#&\'#/"!&,).U &%%2\xBB""6\xBB7\xBC/>#%<2\xBB""6\xBB7\xBC=.##&&!&\'#/#$+")("\'#&\'#/"!&,)'), peg$decode("%;Y/\x83#$%;G/>#;\\/5$;G/,$;Y/#$+$)($'#(#'#(\"'#&'#0H*%;G/>#;\\/5$;G/,$;Y/#$+$)($'#(#'#(\"'#&'#&/)$8\":\xAA\"\"! )(\"'#&'#"), peg$decode('2\xBD""6\xBD7\xBE.5 &2\x9F""6\x9F7\xA0.) &2\xBF""6\xBF7\xC0'), peg$decode('%;[/\xA9#$%;G/Q#%;D.) &2\xA5""6\xA57\xA6/"!&,)/5$;G/,$;[/#$+$)($\'#(#\'#("\'#&\'#0[*%;G/Q#%;D.) &2\xA5""6\xA57\xA6/"!&,)/5$;G/,$;[/#$+$)($\'#(#\'#("\'#&\'#&/)$8":\xC1""! )("\'#&\'#'), peg$decode('%;]/\xA9#$%;G/Q#%;E.) &2\xA7""6\xA77\xA8/"!&,)/5$;G/,$;]/#$+$)($\'#(#\'#("\'#&\'#0[*%;G/Q#%;E.) &2\xA7""6\xA77\xA8/"!&,)/5$;G/,$;]/#$+$)($\'#(#\'#("\'#&\'#&/)$8":\xC1""! )("\'#&\'#'), peg$decode("%;G/A#%;S/\"!&,)/1$;G/($8#:\xC2#!!)(#'#(\"'#&'#"), peg$decode("%;^/K#;G/B$%;S/\"!&,)/2$;G/)$8$:\xC3$\"#!)($'#(#'#(\"'#&'#"), peg$decode(';`.) &;^.# &;_'), peg$decode('%;a/_#$%;G/,#;a/#$+")("\'#&\'#06*%;G/,#;a/#$+")("\'#&\'#&/)$8":\xC4""! )("\'#&\'#')],
    peg$currPos = 0,
    peg$savedPos = 0,
    peg$posDetailsCache = [{
      line: 1,
      column: 1
    }],
    peg$maxFailPos = 0,
    peg$maxFailExpected = [],
    peg$silentFails = 0,
    peg$resultsCache = {},
    peg$result;
  if ('startRule' in options) {
    if (!(options.startRule in peg$startRuleIndices)) {
      throw new Error('Can\'t start parsing from rule "' + options.startRule + '".');
    }
    peg$startRuleIndex = peg$startRuleIndices[options.startRule];
  }
  function text() {
    return input.substring(peg$savedPos, peg$currPos);
  }
  function location() {
    return peg$computeLocation(peg$savedPos, peg$currPos);
  }
  function expected(description, location) {
    location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos);
    throw peg$buildStructuredError([peg$otherExpectation(description)], input.substring(peg$savedPos, peg$currPos), location);
  }
  function error(message, location) {
    location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos);
    throw peg$buildSimpleError(message, location);
  }
  function peg$literalExpectation(text, ignoreCase) {
    return {
      type: 'literal',
      text: text,
      ignoreCase: ignoreCase
    };
  }
  function peg$classExpectation(parts, inverted, ignoreCase) {
    return {
      type: 'class',
      parts: parts,
      inverted: inverted,
      ignoreCase: ignoreCase
    };
  }
  function peg$anyExpectation() {
    return {
      type: 'any'
    };
  }
  function peg$endExpectation() {
    return {
      type: 'end'
    };
  }
  function peg$otherExpectation(description) {
    return {
      type: 'other',
      description: description
    };
  }
  function peg$computePosDetails(pos) {
    var details = peg$posDetailsCache[pos],
      p;
    if (details) {
      return details;
    } else {
      p = pos - 1;
      while (!peg$posDetailsCache[p]) {
        p--;
      }
      details = peg$posDetailsCache[p];
      details = {
        line: details.line,
        column: details.column
      };
      while (p < pos) {
        if (input.charCodeAt(p) === 10) {
          details.line++;
          details.column = 1;
        } else {
          details.column++;
        }
        p++;
      }
      peg$posDetailsCache[pos] = details;
      return details;
    }
  }
  function peg$computeLocation(startPos, endPos) {
    var startPosDetails = peg$computePosDetails(startPos),
      endPosDetails = peg$computePosDetails(endPos);
    return {
      start: {
        offset: startPos,
        line: startPosDetails.line,
        column: startPosDetails.column
      },
      end: {
        offset: endPos,
        line: endPosDetails.line,
        column: endPosDetails.column
      }
    };
  }
  function peg$fail(expected) {
    if (peg$currPos < peg$maxFailPos) {
      return;
    }
    if (peg$currPos > peg$maxFailPos) {
      peg$maxFailPos = peg$currPos;
      peg$maxFailExpected = [];
    }
    peg$maxFailExpected.push(expected);
  }
  function peg$buildSimpleError(message, location) {
    return new peg$SyntaxError(message, null, null, location);
  }
  function peg$buildStructuredError(expected, found, location) {
    return new peg$SyntaxError(peg$SyntaxError.buildMessage(expected, found), expected, found, location);
  }
  function peg$decode(s) {
    var bc = new Array(s.length),
      i;
    for (i = 0; i < s.length; i++) {
      bc[i] = s.charCodeAt(i) - 32;
    }
    return bc;
  }
  function peg$parseRule(index) {
    var bc = peg$bytecode[index],
      ip = 0,
      ips = [],
      end = bc.length,
      ends = [],
      stack = [],
      params,
      i;
    var key = peg$currPos * 67 + index,
      cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    while (true) {
      while (ip < end) {
        switch (bc[ip]) {
          case 0:
            stack.push(peg$consts[bc[ip + 1]]);
            ip += 2;
            break;
          case 1:
            stack.push(void 0);
            ip++;
            break;
          case 2:
            stack.push(null);
            ip++;
            break;
          case 3:
            stack.push(peg$FAILED);
            ip++;
            break;
          case 4:
            stack.push([]);
            ip++;
            break;
          case 5:
            stack.push(peg$currPos);
            ip++;
            break;
          case 6:
            stack.pop();
            ip++;
            break;
          case 7:
            peg$currPos = stack.pop();
            ip++;
            break;
          case 8:
            stack.length -= bc[ip + 1];
            ip += 2;
            break;
          case 9:
            stack.splice(-2, 1);
            ip++;
            break;
          case 10:
            stack[stack.length - 2].push(stack.pop());
            ip++;
            break;
          case 11:
            stack.push(stack.splice(stack.length - bc[ip + 1], bc[ip + 1]));
            ip += 2;
            break;
          case 12:
            stack.push(input.substring(stack.pop(), peg$currPos));
            ip++;
            break;
          case 13:
            ends.push(end);
            ips.push(ip + 3 + bc[ip + 1] + bc[ip + 2]);
            if (stack[stack.length - 1]) {
              end = ip + 3 + bc[ip + 1];
              ip += 3;
            } else {
              end = ip + 3 + bc[ip + 1] + bc[ip + 2];
              ip += 3 + bc[ip + 1];
            }
            break;
          case 14:
            ends.push(end);
            ips.push(ip + 3 + bc[ip + 1] + bc[ip + 2]);
            if (stack[stack.length - 1] === peg$FAILED) {
              end = ip + 3 + bc[ip + 1];
              ip += 3;
            } else {
              end = ip + 3 + bc[ip + 1] + bc[ip + 2];
              ip += 3 + bc[ip + 1];
            }
            break;
          case 15:
            ends.push(end);
            ips.push(ip + 3 + bc[ip + 1] + bc[ip + 2]);
            if (stack[stack.length - 1] !== peg$FAILED) {
              end = ip + 3 + bc[ip + 1];
              ip += 3;
            } else {
              end = ip + 3 + bc[ip + 1] + bc[ip + 2];
              ip += 3 + bc[ip + 1];
            }
            break;
          case 16:
            if (stack[stack.length - 1] !== peg$FAILED) {
              ends.push(end);
              ips.push(ip);
              end = ip + 2 + bc[ip + 1];
              ip += 2;
            } else {
              ip += 2 + bc[ip + 1];
            }
            break;
          case 17:
            ends.push(end);
            ips.push(ip + 3 + bc[ip + 1] + bc[ip + 2]);
            if (input.length > peg$currPos) {
              end = ip + 3 + bc[ip + 1];
              ip += 3;
            } else {
              end = ip + 3 + bc[ip + 1] + bc[ip + 2];
              ip += 3 + bc[ip + 1];
            }
            break;
          case 18:
            ends.push(end);
            ips.push(ip + 4 + bc[ip + 2] + bc[ip + 3]);
            if (input.substr(peg$currPos, peg$consts[bc[ip + 1]].length) === peg$consts[bc[ip + 1]]) {
              end = ip + 4 + bc[ip + 2];
              ip += 4;
            } else {
              end = ip + 4 + bc[ip + 2] + bc[ip + 3];
              ip += 4 + bc[ip + 2];
            }
            break;
          case 19:
            ends.push(end);
            ips.push(ip + 4 + bc[ip + 2] + bc[ip + 3]);
            if (input.substr(peg$currPos, peg$consts[bc[ip + 1]].length).toLowerCase() === peg$consts[bc[ip + 1]]) {
              end = ip + 4 + bc[ip + 2];
              ip += 4;
            } else {
              end = ip + 4 + bc[ip + 2] + bc[ip + 3];
              ip += 4 + bc[ip + 2];
            }
            break;
          case 20:
            ends.push(end);
            ips.push(ip + 4 + bc[ip + 2] + bc[ip + 3]);
            if (peg$consts[bc[ip + 1]].test(input.charAt(peg$currPos))) {
              end = ip + 4 + bc[ip + 2];
              ip += 4;
            } else {
              end = ip + 4 + bc[ip + 2] + bc[ip + 3];
              ip += 4 + bc[ip + 2];
            }
            break;
          case 21:
            stack.push(input.substr(peg$currPos, bc[ip + 1]));
            peg$currPos += bc[ip + 1];
            ip += 2;
            break;
          case 22:
            stack.push(peg$consts[bc[ip + 1]]);
            peg$currPos += peg$consts[bc[ip + 1]].length;
            ip += 2;
            break;
          case 23:
            stack.push(peg$FAILED);
            if (peg$silentFails === 0) {
              peg$fail(peg$consts[bc[ip + 1]]);
            }
            ip += 2;
            break;
          case 24:
            peg$savedPos = stack[stack.length - 1 - bc[ip + 1]];
            ip += 2;
            break;
          case 25:
            peg$savedPos = peg$currPos;
            ip++;
            break;
          case 26:
            params = bc.slice(ip + 4, ip + 4 + bc[ip + 3]);
            for (i = 0; i < bc[ip + 3]; i++) {
              params[i] = stack[stack.length - 1 - params[i]];
            }
            stack.splice(stack.length - bc[ip + 2], bc[ip + 2], peg$consts[bc[ip + 1]].apply(null, params));
            ip += 4 + bc[ip + 3];
            break;
          case 27:
            stack.push(peg$parseRule(bc[ip + 1]));
            ip += 2;
            break;
          case 28:
            peg$silentFails++;
            ip++;
            break;
          case 29:
            peg$silentFails--;
            ip++;
            break;
          default:
            throw new Error('Invalid opcode: ' + bc[ip] + '.');
        }
      }
      if (ends.length > 0) {
        end = ends.pop();
        ip = ips.pop();
      } else {
        break;
      }
    }
    peg$resultsCache[key] = {
      nextPos: peg$currPos,
      result: stack[0]
    };
    return stack[0];
  }
  const MISSING = {
    type: 'MISSING',
    recovered: true
  };
  function extractOptional(optional, index) {
    return optional ? optional[index] : null;
  }
  function extractList(list, index) {
    return list.map(function (element) {
      return element[index];
    });
  }
  function buildList(head, tail, index) {
    return [head].concat(extractList(tail, index));
  }
  function buildExpressionList(head, tail, index) {
    return [head].concat(extractList(tail, index));
  }
  function extendLocation(location, count) {
    return {
      start: location.start,
      end: {
        line: location.end.line,
        column: location.end.column + count,
        offset: location.end.offset + count
      }
    };
  }
  function getUnaryExpressionType(operator) {
    switch (operator) {
      case '+':
        return 'POSITIVE';
      case '-':
        return 'NEGATIVE';
      case '!':
        return 'NOT';
      default:
        {
          throw new Error('Unknown unary operator');
        }
    }
  }
  function getBinaryExpressionType(operator) {
    switch (operator) {
      case '+':
        return 'ADD';
      case '-':
        return 'SUBTRACT';
      case '*':
        return 'MULTIPLY';
      case '/':
        return 'DIVIDE';
      case '%':
        return 'MODULUS';
      case '>':
        return 'GREATER';
      case '<':
        return 'LESS';
      case '>=':
        return 'GREATER_OR_EQUAL';
      case '<=':
        return 'LESS_OR_EQUAL';
      case '=':
        return 'EQUAL';
      case '==':
        return 'EQUAL';
      case '!=':
        return 'NOT_EQUAL';
      case 'AND':
        return 'AND';
      case 'OR':
        return 'OR';
      case 'and':
        return 'AND';
      case 'or':
        return 'OR';
      case '&&':
        return 'AND';
      case '||':
        return 'OR';
      default:
        {
          throw new Error('Unknown binary operator');
        }
    }
  }
  function buildBinaryExpression(head, tail, location) {
    return tail.reduce(function (result, element) {
      const operator = element[1];
      return {
        type: getBinaryExpressionType(operator),
        operator,
        left: result,
        right: element[3],
        recovered: false,
        location
      };
    }, head);
  }
  function optionalList(value) {
    return value !== null ? value : [];
  }
  function getSymbolName(input) {
    switch (input) {
      case ',':
        return 'COMMA';
      case '{':
        return 'LEFT_BRACE';
      case '}':
        return 'RIGHT_BRACE';
      case '(':
        return 'LEFT_PARENTHESIS';
      case ')':
        return 'RIGHT_PARENTHESIS';
      case '[':
        return 'LEFT_BRACKET';
      case ']':
        return 'RIGHT_BRACKET';
      case "'":
        return 'SINGLE_QUOTE';
      case '"':
        return 'DOUBLE_QUOTE';
      default:
        throw new Error('Unknown token name');
    }
  }
  function expressions(exps) {
    return {
      type: 'EXPRESSIONS',
      expressions: exps,
      recovered: true,
      location: location()
    };
  }
  function symbol(input) {
    return {
      type: 'SYMBOL',
      name: getSymbolName(input),
      text: text(),
      recovered: true,
      location: location()
    };
  }
  function unrecognized(input) {
    return {
      type: 'UNRECOGNIZED',
      text: text(),
      recovered: true,
      location: location()
    };
  }
  peg$result = peg$parseRule(peg$startRuleIndex);
  if (peg$result !== peg$FAILED && peg$currPos === input.length) {
    return peg$result;
  } else {
    if (peg$result !== peg$FAILED && peg$currPos < input.length) {
      peg$fail(peg$endExpectation());
    }
    throw peg$buildStructuredError(peg$maxFailExpected, peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null, peg$maxFailPos < input.length ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1) : peg$computeLocation(peg$maxFailPos, peg$maxFailPos));
  }
}

/* eslint-enable */

export const __SyntaxError = peg$SyntaxError;
export const __parseWithRecovery = peg$parse;